module.exports = __webpack_public_path__ + "static/media/4.23_preview.9491ff30.png";